import styled from "styled-components";

export const InputTextLabelText = styled.p<{ color?: string, marginbottom?: string }>`
  font-size: 12px;
  font-family: 'Inter', Arial, sans-serif;  
  color: #9CA3AF;
  margin:0;
  padding:0;
  margin-bottom: ${({ marginbottom }) => marginbottom || '0'};
`;
